import {
  EXPORT_MONITORING_QUEUE,
} from '../types';

import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  exportMonitoringQueue,
  exportMonitoringQueuePending,
  exportMonitoringQueueFulfilled,
  exportMonitoringQueueRejected,
} = createAsyncActions(EXPORT_MONITORING_QUEUE, 'exportMonitoringQueue');


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/actions/exportMonitoringQueueActions.js